




































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { showError, showSuccess, showWarning } from "@/utils/Common";
import {
  MSG_ADD_SUCCESS,
  MSG_INVALID_PAGE,
  MSG_MODIFY_SUCCESS,
} from "@/configs/Consts";

@Component
export default class EmployeeForm extends Vue {
  @Prop({ type: Object, default: () => ({}) })
  employeeItem!: any;

  isEditEmployee() {
    return this.employeeItem && this.employeeItem.id;
  }

  queryDepartment(query: string, cb: any) {
    const allData = this.$store.getters["enums/getEnumsByKey"]("Department");
    const datas: Array<any> = [];
    allData.forEach((data: any) => {
      datas.push({ value: data.label });
    });
    const results = query
      ? datas.filter((data: any) => {
          return data.value.toLowerCase().indexOf(query.toLowerCase()) === 0;
        })
      : datas;
    cb(results);
  }

  queryPosition(query: string, cb: any) {
    const allData = this.$store.getters["enums/getEnumsByKey"]("Position");
    const datas: Array<any> = [];
    allData.forEach((data: any) => {
      datas.push({ value: data.label });
    });
    const results = query
      ? datas.filter((data: any) => {
          return data.value.toLowerCase().indexOf(query.toLowerCase()) === 0;
        })
      : datas;
    cb(results);
  }

  saveEmployee() {
    const form = this.$refs.employeeForm as any;
    form.validate((isValid: boolean) => {
      if (!isValid) {
        showWarning(MSG_INVALID_PAGE);
        return;
      }
      const employeeData = JSON.parse(JSON.stringify(this.employeeItem));
      this.$store
        .dispatch(
          this.isEditEmployee() ? "employee/updateEmployee" : "employee/addEmployee",
          employeeData
        )
        .then(() => {
          this.$emit("update:employeeItem", {});
          showSuccess(this.isEditEmployee() ? MSG_MODIFY_SUCCESS : MSG_ADD_SUCCESS);
          this.$emit("data-success");
          // reload enums
          this.$store.dispatch("enums/getEnums");
        })
        .catch(({ message }) => showError(message));
    });
  }
}
